import React from 'react'

import { arrayOf, bool, shape, string } from 'prop-types'

import LazyAiSignInModal from 'Pods/LazyLoaded/AiSignInModal/LazyAiSignInModal'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CenteredTitle from './Components/CenteredTitle/CenteredTitle'
import CommunityGallery from './Components/CommunityGallery/CommunityGallery'
import CreateWithAi from './Components/CreateWithAi/CreateWithAi'
import CTABanner from './Components/CTABanner/CTABanner'
import FAQs from './Components/FAQs/FAQs'
import GoToTop from './Components/GoToTop/GoToTop'
import UpgradeHeader from './Components/UpgradeHeader/UpgradeHeader'
import useAuthModalTrigger from './Hooks/useAuthModalTrigger'

// This is a cacheable fast page, so per-user 3D Studio subscription state is not
// available at SSR time -- it is delivered client-side via window.pageConfig
// (built in has_fast_application_state_helpers.rb, flushed by /load-services.js).
// Sections read only the fields they need with usePageConfig (see UpgradeHeader),
// so this root stays a plain layout. Four non-user-specific values are threaded
// from SSR props (see react_props_ai_sub_landing): extractingCoreStyles, an
// SSR-render-time flag (false outside extraction) that lets per-user sections
// force-render during the critical-CSS extraction pass so their styles are
// captured; communityGalleryCategories, the shared search-aggregation chips;
// subscriptionPaymentFormUrl, the absolute payment-form URL the CTA falls back to
// before per-user page config hydrates (and for signed-out visitors); and
// freeTrialAvailable, the class-level trial-pool flag that lets UpgradeHeader render
// its signed-out layout at SSR (matching hydration) instead of popping in afterwards.
function AiSubLanding({
  extractingCoreStyles = false,
  communityGalleryCategories = EMPTY_ARRAY,
  subscriptionPaymentFormUrl = '',
  freeTrialAvailable = false,
}) {
  const { signInModalMode, closeSignInModal } = useAuthModalTrigger()

  return (
    <div className="ai-sub-landing">
      <UpgradeHeader
        extractingCoreStyles={extractingCoreStyles}
        subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
        freeTrialAvailable={freeTrialAvailable}
      />
      <CreateWithAi />
      <CenteredTitle />
      <CommunityGallery
        categories={communityGalleryCategories}
        extractingCoreStyles={extractingCoreStyles}
      />
      <FAQs />
      <CTABanner subscriptionPaymentFormUrl={subscriptionPaymentFormUrl} />
      <GoToTop />
      {signInModalMode && (
        <LazyAiSignInModal mode={signInModalMode} onClose={closeSignInModal} />
      )}
    </div>
  )
}

AiSubLanding.propTypes = {
  extractingCoreStyles: bool,
  communityGalleryCategories: arrayOf(shape({
    name: string.isRequired,
    value: string.isRequired,
  })),
  subscriptionPaymentFormUrl: string,
  freeTrialAvailable: bool,
}

export default AiSubLanding
